    
let parsedCSVData = [];

/**
 * @desc Disable "Add to Cart" button on page load until a CSV file is uploaded.
 */
document.addEventListener("DOMContentLoaded", function() {
  document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
});

let isBulkUploadMode = false;

/**
 * @desc Opens the bulk Excel modal, allowing users to upload a CSV file.
 */
function openBulkExcelModal(event) {
  event.preventDefault(); // Prevent default form submission
  event.stopImmediatePropagation(); // Prevent event bubbling
  event.stopImmediatePropagation();
  isBulkUploadMode = true;
  document.querySelector('.group-excel-bulk-upload-wrapper').classList.remove('hide');
  document.querySelector('.group-excel-bulk-upload-wrapper').setAttribute('data-bulk-excel', true);
  resetCustomizationData();
  document.querySelector('#addToCartButton').removeAttribute('data-bulk-group');
  document.querySelector('#addToCartButton').setAttribute('data-bulk-excel', true);
  document.body.style.overflow = 'hidden';
}

/**
 * @desc Closes the bulk Excel modal.
 */
function closeBulkExcelModal() {
  isBulkUploadMode = false;
  document.querySelector('.group-excel-bulk-upload-wrapper').classList.add('hide');
   document.querySelector('#addToCartButton').setAttribute('data-bulk-group', true);
  document.querySelector('.group-excel-bulk-upload-wrapper').removeAttribute('data-bulk-excel');
  document.querySelector('#addToCartButton').removeAttribute('data-bulk-excel');
}

/**
 * @desc Event listener for handling CSV file upload.
 */
document.getElementById('csvFileInput').addEventListener('change', handleFile);

/**
 * @desc Reads the uploaded file and triggers the CSV parsing.
 * @param {Event} event - The event triggered by file upload.
 */
function handleFile(event) {
  const file = event.target.files[0];
  if (!file) {
    return;
  }

   // Ensure the uploaded file is of type CSV
  const allowedTypes = ['text/csv', 'application/vnd.ms-excel'];
  if (!allowedTypes.includes(file.type)) {
    document.querySelector('.csv-error').innerHTML = 'Only CSV files are allowed.';
    document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
    return;
  }
  
  const reader = new FileReader();
  reader.onload = function (e) {
    const csvData = e.target.result;
    parseCSV(csvData);  // Parse the CSV data
  };
  reader.readAsText(file);
}

/**
 * @desc Parses the CSV data and stores it in the global variable `parsedCSVData`.
 * @param {String} csvData - The CSV data read from the file.
 */
function parseCSV(csvData) {
  Papa.parse(csvData, {
    header: true,
    dynamicTyping: true,
    complete: function (results) {
      parsedCSVData = results.data;  // Store parsed data
      
      const nameCount = parsedCSVData.filter(item => item.Name).length;
       // Check if the number of rows exceeds the limit of 500 names
      if (nameCount > 500) {
        document.querySelector('.csv-error').innerHTML = "The limit of 500 names has been exceeded. Please upload a sheet with 500 or fewer names.";
        document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
        return;
      }
     
      const ischeckName = checkName(parsedCSVData);

      document.querySelector('.csv-error').innerHTML = "";

      if (ischeckName !== true) {
        document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
        document.querySelector('.csv-error').innerHTML = ischeckName.error;
        return;
      }
      
      // Check if the number of names exceeds the available inventory
      const availableQuantity = parseInt(document.querySelector(".variant-qty-available").getAttribute("data-available-quantity"));
      if (nameCount > availableQuantity) {
        document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
        document.querySelector('.csv-error').innerHTML = `The no. of names(${nameCount}) added in sheet exceeds the existing available inventory (${availableQuantity}).`;
      } else {
        document.querySelector("#bulk-excel-add-to-cart-button").disabled = false;
      }
    },
    error: function (error) {
      console.error('Error parsing CSV:', error.message);
      document.querySelector("#bulk-excel-add-to-cart-button").disabled = true;
    }
  });
}

/**
 * @desc Checks the uploaded CSV data for valid name and font placement, ensuring there are no errors.
 * @param {Array} inputArray - The array of data parsed from the CSV file.
 * @returns {Object|Boolean} - Returns an error object if validation fails, otherwise returns `true`.
 */

function checkName(inputArray) {
  const filteredArray = inputArray.filter(item => item.Name !== null);
  let index = 0;

  // Regular expression to allow only English letters, spaces, and common punctuation
  const englishRegex = /^[A-Za-z0-9\s]+$/;
  
  // Loop through each item in the filtered array
  for (const item of filteredArray) {
    if (!inputArray[index].Name) {
      return { error: `Name column missing.` };
    }
    index += 1;

    // Check if the name exceeds the character limit
    if (item.Name && item.Name.length > 11) {
      return { error: `${item.Name} character limit exceeded.` };
    }

    // Validate that the name contains only English characters and spaces
    if (!englishRegex.test(item.Name)) {
      return { error: `Name contains invalid characters. Only English letters are allowed.` };
    }

    // Check for the presence of emoji or other non-English characters
    const emojiOrNonEnglishRegex = /[^\u0000-\u007F]+/;  // Detects any non-ASCII character (emojis, non-English characters)
    if (emojiOrNonEnglishRegex.test(item.Name)) {
      return { error: `Name contains emojis or non-English characters, which are not allowed.` };
    }
  }
  return true;
}

